import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { ToastService } from '../services/toast.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private logger: NGXLogger,
    private toastService: ToastService,
    private translateService: TranslateService,
    private zone: NgZone
  ) {}

  handleError(err: Error): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    this.logger.error('GlobalErrorHandler handleError:', err);

    if (chunkFailedMessage.test(err.message)) {
      setTimeout(() => {
        window.location.reload();
        // add 500ms delay to avoid continuous reloads
      }, 500);
      return;
    }

    this.translateService.get('SigvLibrary.UnknowError').subscribe({
      next: (msg) => {
        this.zone.run(() => {
          this.toastService.error(msg);
        });
      },
    });
  }
}
